import TextWithRegisteredMark from "~/componentsDS/TextWithRegisteredMark";
import AuthorInfo from "./AuthorInfo";
import { type DoubleInfoTestimonialV3 } from "./data";
import { cn } from "~/lib/utils";

const DoubleInfoSlide = ({
    testimonial,
    className,
}: {
    testimonial: DoubleInfoTestimonialV3;
    className?: string;
}) => {
    return (
        <div className={cn("h-[514px] flex flex-col gap-4", className)}>
            {testimonial.feedbacks.map(({ text, author, photo, photoAlt }) => (
                <div
                    key={author}
                    className="bg-[#E9EDF7] rounded-3xl overflow-hidden flex flex-col flex-1 px-6 py-6 md:px-8"
                >
                    <p
                        className={cn(
                            "relative font-suisseBP leading-[1.4] md:leading-[1.1] tracking-[-0.01em] text-primary500 mb-auto text-[22px] lg:text-[32px] font-normal md:font-light",
                            testimonial.textClassName
                        )}
                    >
                        <span className="absolute -translate-x-full">&ldquo;</span>
                        {typeof text === "string" ? (
                            <TextWithRegisteredMark text={text} />
                        ) : (
                            text
                        )}
                        <span>&rdquo;</span>
                    </p>

                    <AuthorInfo
                        photo={photo}
                        author={author}
                        photoAlt={photoAlt}
                    />
                </div>
            ))}
        </div>
    );
};

export default DoubleInfoSlide;
